import { render, staticRenderFns } from "./tip-icon.vue?vue&type=template&id=2f851602&scoped=true&"
import script from "./tip-icon.vue?vue&type=script&lang=ts&"
export * from "./tip-icon.vue?vue&type=script&lang=ts&"
import style0 from "./tip-icon.vue?vue&type=style&index=0&id=2f851602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f851602",
  null
  
)

export default component.exports